//footer toggle
document.addEventListener('DOMContentLoaded', function() {
  // Footer toggle functionality
  const toggleBtns = document.querySelectorAll('.toggleBtn');
  
  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Hide other toggle blocks and remove active class
      toggleBtns.forEach(function(otherBtn) {
        if (otherBtn !== btn) {
          const otherBlock = otherBtn.parentElement.querySelector('.toggleBlock');
          if (otherBlock) {
            otherBlock.style.display = 'none';
          }
          otherBtn.classList.remove('active');
        }
      });
      
      // Toggle current block
      const currentBlock = btn.parentElement.querySelector('.toggleBlock');
      if (currentBlock) {
        if (currentBlock.style.display === 'none' || currentBlock.style.display === '') {
          currentBlock.style.display = 'block';
        } else {
          currentBlock.style.display = 'none';
        }
      }
      btn.classList.toggle('active');
    });
  });

  // Read more functionality
  const readMoreBtns = document.querySelectorAll('.read-more-btn');
  
  readMoreBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.classList.toggle('active');
      
      const readMoreContent = btn.parentElement.querySelector('.read-more-content');
      if (readMoreContent) {
        if (btn.classList.contains('active')) {
          readMoreContent.style.display = 'block';
          btn.innerHTML = 'Read Less';
        } else {
          readMoreContent.style.display = 'none';
          btn.innerHTML = 'Read More';
        }
      }
    });
  });
});